module.exports = __webpack_public_path__ + "static/media/globerack4x3.6846e480.webp";